import { Box, Grid, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "react-admin";
import { CurriculumDisciplineTypeLabels } from "utils/choices";
import { CurriculumDisicplineTypes } from "utils/constants";
import { attestationColumns } from "./columns";
import AttestationRow from "./AttestationRow";

const DisciplineBlock = ({ discipline, rows, canManage, onAdd, onRemove }) => {
  const typeName = CurriculumDisciplineTypeLabels.find(choice => choice.id === discipline.type)?.name;
  // Orphan disciplines are no longer in the curriculum - their rows may be corrected, but no new ones added.
  const canAdd = canManage && discipline.type !== CurriculumDisicplineTypes.None;

  const disciplineLabel = (
    <>
      {discipline.disciplineNameBg}
      {typeName && (
        <Typography
          variant="caption"
          color="text.secondary"
          component="div"
        >
          {typeName}
        </Typography>
      )}
    </>
  );

  return (
    <Box sx={{ borderTop: "1px solid", borderColor: "divider", py: 1 }}>
      {rows.length ? (
        // The discipline name is printed once, on the first row of its block.
        rows.map(({ field, index }, position) => (
          <AttestationRow
            key={field.fieldKey}
            attestation={field}
            index={index}
            disciplineLabel={position === 0 ? disciplineLabel : null}
            canManage={canManage}
            onRemove={onRemove}
          />
        ))
      ) : (
        <Grid
          container
          spacing={1}
          alignItems="center"
          sx={{ py: 0.5 }}
        >
          <Grid
            item
            xs={12}
            md={attestationColumns.discipline.md}
          >
            <Typography
              variant="body2"
              component="div"
            >
              {disciplineLabel}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={12 - attestationColumns.discipline.md}
          >
            <Typography
              variant="body2"
              color="text.secondary"
            >
              Няма заверки
            </Typography>
          </Grid>
        </Grid>
      )}
      {canAdd && (
        <Button
          label="Добави заверка"
          size="small"
          startIcon={<AddIcon />}
          onClick={() => onAdd(discipline.disciplineId)}
        />
      )}
    </Box>
  );
};

export default DisciplineBlock;
